import { alpha } from "@mui/material";

const styles = (theme) => ({
    paper: {
        display: "flex",
        flexDirection: "column",
        gap: 2,
        position: "relative",
    },
    paperFluxo: {
        borderRadius: "16px",
        flex: 1,
        height: "100%",
        overflowY: "auto",
        position: "relative",
        p: 1,
    },
    boxBlur: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "78px",
        zIndex: 2,
        backgroundColor: alpha(theme.palette.background.paper, 0.8),
        backdropFilter: "blur(6px)",
        transform: "translateY(7px)",
        borderTopLeftRadius: "30px",
        clipPath: "inset(0px 16px 0 10px)",
    },

    // abas estilo clientesSwap
    containerTabsNActionButtons: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        mt: 1,
    },
    tabs: {
        minHeight: 32,
        "& .MuiTabs-indicator": {
            display: "none",
        },
    },
    tab: {
        minHeight: 32,
        paddingY: 0.5,
        px: 1,
        mx: 0.05,
        fontSize: "0.875rem",
        textTransform: "none",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        border: "1px solid transparent",
        borderBottom: "none",
        transition: "all 0.2s ease",
    },
    tabLabel: {
        display: "flex",
        alignItems: "center",
        gap: 0.5,
    },

    // formulário (área principal)
    formPaper: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        p: 3,
        borderRadius: "16px",
        height: "100%",
        overflowY: "auto",
    },
    headerForm: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1,
    },
    chipList: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexWrap: "wrap",
        listStyle: "none",
        p: 0.5,
        m: 0,
        gap: "5px",
    },
    textTitle: {
        fontWeight: 500,
        fontSize: "15px",
        lineHeight: 1.5,
        display: "flex",
    },
    textData: {
        fontWeight: 400,
        fontSize: "15px",
        lineHeight: 1.5,
        display: "flex",
    },
    macroCampo: { fontSize: "16px", width: "220px" },
    textfield: { width: "220px" },
    styleButtons: { width: "40px", height: "40px" },

    // estado vazio (sem seleção)
    emptyStateBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        flexDirection: "column",
        gap: 1,
        color: theme.palette.text.disabled,
    },

    // botão de busca
    searchField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 2,
        },
    },

    // formulário do dashboard_schema (schemaBuilder)
    schemaHeader: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
        pb: 1,
    },
    schemaTitulo: {
        fontSize: "1.05rem",
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    schemaContagem: {
        fontSize: "0.78rem",
        color: theme.palette.text.disabled,
    },
    schemaAcao: {
        textTransform: "none",
        fontSize: "0.8rem",
        fontWeight: 500,
        color: theme.palette.primary.main,
        minWidth: 0,
        px: 1,
        "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.08) },
    },

    abaCard: {
        borderRadius: "12px",
        overflow: "hidden",
        borderColor: theme.palette.divider,
        bgcolor: theme.palette.background.paper,
    },
    abaHeader: {
        px: 1.5,
        py: 1,
        cursor: "pointer",
        bgcolor: alpha(theme.palette.primary.main, 0.05),
        "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.1) },
    },
    abaChaveTitulo: {
        fontFamily: "monospace",
        fontSize: "0.95rem",
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    abaRotulo: {
        fontSize: "0.78rem",
        color: theme.palette.text.secondary,
    },
    abaContagem: {
        fontSize: "0.72rem",
        color: theme.palette.text.disabled,
    },
    abaAviso: {
        fontSize: "0.72rem",
        fontStyle: "italic",
        color: theme.palette.chip.main.attention,
    },

    // faixa de cabeçalho das colunas
    colunasHeader: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.75,
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    colunaLabel: {
        fontSize: "0.62rem",
        fontWeight: 600,
        letterSpacing: "0.09em",
        textTransform: "uppercase",
        color: theme.palette.text.disabled,
    },

    slotRow: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 1.25,
        borderBottom: `1px solid ${theme.palette.divider}`,
        "&:last-of-type": { borderBottom: "none" },
    },
    colSlot: {
        width: "230px",
        flexShrink: 0,
    },
    colItens: {
        flex: 1,
        minWidth: 0,
    },
    colAcoes: {
        display: "flex",
        gap: 0.5,
        flexShrink: 0,
    },

    // caixa "input" com borda
    caixaCampo: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "8px",
        bgcolor: theme.palette.background.default,
        px: 1,
        py: 0.5,
        minHeight: "40px",
        display: "flex",
        alignItems: "center",
        transition: "border-color 0.15s ease",
        "&:hover": { borderColor: alpha(theme.palette.primary.main, 0.5) },
    },

    // versão não-interativa da caixaCampo (modo leitura)
    caixaCampoLeitura: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "8px",
        bgcolor: alpha(theme.palette.background.default, 0.6),
        px: 1,
        py: 0.5,
        minHeight: "40px",
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        flexWrap: "wrap",
    },
    slotChaveMono: {
        fontFamily: "monospace",
        fontSize: "0.85rem",
        color: theme.palette.text.primary,
    },
    // fonte única de chip pra leitura e edição
    chipItem: {
        height: 24,
        borderRadius: "6px",
        bgcolor: alpha(theme.palette.primary.main, 0.16),
        color:
            theme.palette.mode === "dark"
                ? theme.palette.primary.lighter
                : theme.palette.primary.dark,
    },

    // variante vermelha do botão de linha
    botaoAcaoLinhaPerigo: {
        textTransform: "none",
        fontSize: "0.72rem",
        minWidth: "34px",
        px: 1,
        py: 0.5,
        borderRadius: "8px",
        border: `1px solid ${alpha(theme.palette.error.main, 0.5)}`,
        color: theme.palette.error.main,
        "&:hover": {
            borderColor: theme.palette.error.main,
            bgcolor: alpha(theme.palette.error.main, 0.08),
        },
    },

    botaoAcaoLinha: {
        textTransform: "none",
        fontSize: "0.72rem",
        minWidth: "34px",
        px: 1,
        py: 0.5,
        borderRadius: "8px",
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.secondary,
        "&:hover": {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            bgcolor: alpha(theme.palette.primary.main, 0.06),
        },
    },

    abaFooter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: 1.5,
        py: 1,
        borderTop: `1px solid ${theme.palette.divider}`,
        flexWrap: "wrap",
    },
    linkAdicionar: {
        textTransform: "none",
        fontSize: "0.8rem",
        fontWeight: 500,
        color: theme.palette.primary.main,
        minWidth: 0,
        px: 0.5,
        "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.08) },
    },
    linkDiscreto: {
        textTransform: "none",
        fontSize: "0.75rem",
        color: theme.palette.text.disabled,
        minWidth: 0,
        px: 0.5,
        "&:hover": {
            color: theme.palette.primary.main,
            bgcolor: "transparent",
        },
    },

    slotChaveLeitura: {
        fontFamily: "monospace",
        fontSize: "0.75rem",
        color: theme.palette.text.secondary,
        minWidth: "150px",
    },
    botaoAdicionar: {
        textTransform: "none",
        borderStyle: "dashed",
        borderWidth: 1,
        borderColor: theme.palette.divider,
        color: theme.palette.primary.main,
    },
    botaoSecundario: {
        textTransform: "none",
        fontSize: "0.75rem",
    },
    alertaAvancado: {
        fontSize: "0.78rem",
        alignItems: "center",
    },

    /* ------------- aplicação em massa (schemaBulkApply) -------------------- */
    bulkTree: {
        maxHeight: "300px",
        overflowY: "auto",
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        p: 1,
    },
    bulkTreeVazia: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "120px",
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
    },
    bulkIndent: {
        pl: 3,
    },
    bulkNivel1: {
        fontSize: "0.9rem",
        fontWeight: 600,
        cursor: "pointer",
    },
    bulkNivel2: {
        fontSize: "0.85rem",
        fontWeight: 500,
        cursor: "pointer",
    },
    bulkNivel3: {
        fontSize: "0.8rem",
    },
    bulkChipSchema: {
        height: 16,
        fontSize: "0.6rem",
    },
    bulkPrevia: {
        maxHeight: "220px",
        overflowY: "auto",
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        p: 1,
    },
    bulkPreviaItem: {
        py: 0.75,
        borderBottom: `1px solid ${theme.palette.divider}`,
        "&:last-of-type": { borderBottom: "none" },
    },
});

export default styles;
